import { ErrorMessage } from '@hookform/error-message'
import Button from '../../../components/Button'
import DragDrop from '../../../components/DragAndDrop'
import BackUpIcon from '../../../icons/BackUpIcon'
import { VIEWPORT_LG } from '../../../utils/constants'
import UploadingPdf from '../../../icons/talentInformation/UploadingPdf'
import useResize from '../../../hooks/useResize'
import { useForm } from 'react-hook-form'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import CustomModal from '../../../components/Modals/CustomModal'
import Swal from 'sweetalert2'
import { uploadPdfAndRegisterTalent } from '../../../services/MyCurriculumn'
import PdfSucessModalIcon from '../../../icons/talentInformation/PdfSucessModalIcon'
import { useNavigate } from 'react-router-dom'
import { handleOpenModal } from '../../../utils'
import HistoryPdfsModal from './HistoryPdfsModal'

const UploadPdfTalentByTm = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const {
    register,
    setValue,
    watch,
    formState: { errors },
  } = useForm()

  const { logo } = watch()
  const viewportSize = useResize()
  const IS_EMPTY_LOGO = logo === ''
  const [isHovered, setIsHovered] = useState(false)
  const BATCH_SIZE = 25;

  function splitIntoBatches(files, batchSize) {
    const batches = [];
    for (let i = 0; i < files.length; i += batchSize) {
      batches.push(files.slice(i, i + batchSize));
    }
    return batches;
  }

  const [batchProgress, setBatchProgress] = useState({ current: 0, total: 0, loading: false });

  const handleUploadPdf = async () => {
    if (IS_EMPTY_LOGO) {
      return;
    }
    const filesArray = Array.from(logo);
    const batches = splitIntoBatches(filesArray, BATCH_SIZE);
    setBatchProgress({ current: 0, total: batches.length, loading: true });

    for (let i = 0; i < batches.length; i++) {
      const batchFiles = batches[i];
      await uploadPdfAndRegisterTalent({ pdf: batchFiles });
      setBatchProgress(prev => ({ ...prev, current: prev.current + 1 }));
    }

    setBatchProgress({ current: batches.length, total: batches.length, loading: false });

    CustomModal({
      Image: () => <PdfSucessModalIcon />,
      title: 'Todos los PDFS han sido registrados exitosamente',
      description: '',
      textPrimaryButton: 'Volver',
      showSecondaryButton: false,
      handlePrimaryButton: () => Swal.close(),
    });
  };

  return (
    <>
      {batchProgress.loading && (
        <div className="profile-extra-container text-on-bg-primary d-flex flex-column font-small fw-bolder justify-content-center align-items-center">
          <UploadingPdf />
          <div>
            Subiendo por lotes de 25 pdfs {batchProgress.current + 1} de {batchProgress.total}
          </div>
        </div>
      )}

      <div className="container-fluid d-flex justify-content-center p-4">
        <div className="card shadow-lg p-4 w-100" style={{ maxWidth: '600px' }}>
          <div
            className={`${viewportSize[0] <= VIEWPORT_LG ? 'gap-2' : ''
              } d-flex flex-column`}
          >
            <h1 className="text-bg-brand fw-bolder mb-3 text-center">
              Registrar Talento desde PDF
            </h1>
            <p className="text-on-bg-primary mb-4">
              Como Talent Manager, puedes registrar un nuevo talento subiendo su
              CV en formato PDF. El sistema procesará la información
              automáticamente.
            </p>

            <div
              className={`${viewportSize[0] <= VIEWPORT_LG
                ? 'w-100 overflow-hidden mt-4'
                : 'w-75'
                } mb-3 d-flex flex-column`}
            >
              <input
                className="d-none"
                id="inputPdf"
                {...register('logo', {
                  required: t('this_field_is_required'),
                  validate: () => {
                    if (logo === 'File type is not supported') {
                      return t('the_file_type_is_not_supported')
                    }
                  },
                })}
              ></input>
              <label className="text-on-bg-primary mb-2 d-block">
                Sube el PDF del CV del Talento
              </label>
              <DragDrop
                name="logo"
                setValue={setValue}
                hoverTitle={t('drop_here')}
                fileTypes={['PDF']}
                isMultiple
                onFileType={(value) => { console.log('value', value) }}
              >
                <div
                  className="cursor-pointer drag-and-drop bg-bg-tertiary font-small p-5 d-flex flex-column justify-content-center align-items-center border border-dashed border-secondary rounded"
                  style={{
                    transition: 'all 0.3s ease',
                    backgroundColor: isHovered ? '#f8f9fa' : '',
                    transform: isHovered ? 'scale(1.02)' : 'scale(1)',
                  }}
                  onMouseEnter={() => setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <BackUpIcon className="mb-3" style={{ fontSize: '3rem' }} />
                  {IS_EMPTY_LOGO ? (
                    <>
                      <div className="d-flex align-items-center gap-1">
                        <span className="text-decoration-underline text-bg-CTA-primary">
                          Sube
                        </span>
                        <span className="text-on-bg-primary">
                          o arrastra el PDF del CV del Talento
                        </span>
                      </div>
                      <span className="text-on-bg-secondary">
                        {t('accepted_formats')}: PDF
                      </span>
                    </>
                  ) : (
                    <span className="text-bg-CTA-primary fw-bolder">
                      {t('file_uploaded_successfully')}
                    </span>
                  )}
                </div>
              </DragDrop>
              <ErrorMessage
                errors={errors}
                name="logo"
                render={({ message }) => (
                  <span className="text-danger font-small">{message}</span>
                )}
              />
            </div>
            <div className="d-flex align-items-center justify-content-start gap-1 mt-3">
              <Button
                className="btn-white border border-on-bg-primary text-on-bg-primary"
                type="button"
                onClick={() => navigate('/tm-talents')}
              >
                Regresar
              </Button>{' '}
              <Button
                className={`${viewportSize[0] <= VIEWPORT_LG ? 'w-50' : ''
                  } btn-bg-CTA-primary text-on-bg-primary inline-text`}
                type="button"
                onClick={handleUploadPdf}
                disabled={IS_EMPTY_LOGO}
              >
                Registrar Talento
              </Button>
              <Button
                className="btn-white border border-on-bg-primary text-on-bg-primary d-flex align-items-center"
                type="button"
                onClick={() => handleOpenModal({
                  id: 'historyModal'
                })}
                title="Ver historial de PDFs cargados"
              >
                Historial de PDFs
              </Button>
            </div>
          </div>
        </div>
      </div>
      <HistoryPdfsModal />
    </>
  )
}

export default UploadPdfTalentByTm
